import styled from 'styled-components'

interface IPhoneNumberFieldStyledProps {
  isShowingPlaceholderIcon?: boolean
}

// Overrides styles defined in react-phone-input-2/lib/material.css to match design system
export const PhoneNumberFieldStyled = styled.div<IPhoneNumberFieldStyledProps>`
  .PhoneInput {
    border-radius: ${(props) => props.theme.typography.pxToRem(4)};
    border: 1px solid ${(props) => props.theme.colors.content.border};
    box-sizing: border-box;
    height: ${(props) => props.theme.typography.pxToRem(36)};
  }

  .PhoneInput--disabled {
    border-color: ${(props) => props.theme.colors.content.border};
    background-color: ${(props) => props.theme.colors.form.field.disabled};
    color: ${(props) => props.theme.colors.text.disabled};
  }

  .PhoneInput:focus-within {
    border-color: ${(props) => props.theme.colors.darkGreen};
  }

  .PhoneInputInput {
    background: transparent;
    font-family: inherit;
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
    font-weight: ${(props) => props.theme.fontWeights.normal};
    border: none;
    margin: 0 ${(props) => props.theme.typography.pxToRem(12)};
    width: '100%;';

    &:disabled {
      border-color: ${(props) => props.theme.colors.content.border};
      background-color: ${(props) => props.theme.colors.form.field.disabled};
      color: ${(props) => props.theme.colors.text.disabled};
    }

    &:focus {
      outline: none;
      box-shadow: none;
      border: none;
    }
  }

  .PhoneInputCountry {
    margin-left: ${(props) => props.theme.typography.pxToRem(12)};
  }

  .PhoneInputCountrySelect + .PhoneInputCountryIcon {
    box-shadow: ${(props) =>
      props.isShowingPlaceholderIcon ? 'none' : '0 0 2px rgba(0, 0, 0, 0.5)'};
    border-radius: 2px;
  }

  .arrow-icon {
    color: ${(props) => props.theme.colors.textPrimary};
    margin-left: ${(props) => props.theme.typography.pxToRem(8)};
  }
`
